import { defineStore } from 'pinia';
import { ref, computed } from 'vue';

const GroupSearchType = {
    Exact: 'exact',
    Partial: 'partial'
};

const useGroupStore = defineStore('group', () => {
    const allGroups = ref([]);
    const searchType = ref(GroupSearchType.Partial);
    const searchTerm = ref('');

    async function fetchGroups() {
        const res = await window.cleanupApi.getGroups();
        allGroups.value = res.data;
    }

    async function updateCompanyNotes(company, notes) {
        await window.cleanupApi.updateCompanyNotes(company.id, notes);
        await fetchGroups();
    }

    const groups = computed(() => {
        let workingList = allGroups.value;

        if (searchTerm.value) {
            if (searchType.value === GroupSearchType.Partial) {
                workingList = workingList.filter(g => g.groupName.toLowerCase().includes(searchTerm.value.toLowerCase()));
            }
            else {
                workingList = workingList.filter(g => g.groupName.toLowerCase() === searchTerm.value.toLowerCase());
            }
        }

        return workingList;
    });

    return {
        searchType,
        searchTerm,
        groups,
        fetchGroups,
        updateCompanyNotes
    };
});

export { useGroupStore, GroupSearchType };
